export const DEFAULT_CONSENT_OPTIONS_STRICT = [];
